// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3101":"4621a0b8659f6efc","9378":"275d685023e88b23"}[chunkId] + ".css";
};